
import { UsuarioBeneficioService } from './../../services/usuario-beneficio.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-alert-detalhes-beneficio',
    templateUrl: './alert-detalhes-beneficio.component.html',
    styleUrls: ['./alert-detalhes-beneficio.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TitleCasePipe]
})
export class AlertDetalhesBeneficioComponent implements OnInit, OnChanges {

  @Input() alertDetalhesBeneficio = false;
  @Output() alertDetalhesBeneficioFechou = new EventEmitter( );

  // ligar o idProduto ao que for selecionado pela pessoa na tela principal
  @Input() idProdutoSelecionado = '';
  public beneficioResponse: any;

  constructor(private readonly usuarioBeneficioService: UsuarioBeneficioService) { }

  ngOnInit(): void {
    this.listarBeneficioSelecionado();
  }
  ngOnChanges(): void {
    this.listarBeneficioSelecionado();
  }

  public cancelarDetalhesBeneficio(){
    this.alertDetalhesBeneficio = false
    this.alertDetalhesBeneficioFechou.emit(this.alertDetalhesBeneficio);
  }

  public listarBeneficioSelecionado(){
    if (this.idProdutoSelecionado?.length > 0){
      this.usuarioBeneficioService.getbenefitByIdProduct(this.idProdutoSelecionado)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            this.beneficioResponse = response.response;
          },
          error: (error) => {
            console.log(error);
          }
        })
    }
  }
}
